<script>
const TableColMixin = {
  data() {
    return {
      tableParameters: {},
      tableColWidth: {}
    }
  },
  methods: {
    setTableParameters(tableId, newWidth, column) {
      let tableParameters = JSON.parse(localStorage.getItem('tableParameters'));
      if (!tableParameters) {
        tableParameters = {};
      }
      if(!tableParameters[tableId]) {
        tableParameters[tableId] = {};
      }
      tableParameters[tableId][column.label] = newWidth;
      localStorage.setItem('tableParameters', JSON.stringify(tableParameters));
    },
    setColumnWidth() {
      const tableParameters = JSON.parse(localStorage.getItem('tableParameters'));
      this.tableParameters = tableParameters || {};
      const tableKeys = Object.keys(this.tableParameters);
      tableKeys.forEach(tableId => {
        this.tableColWidth[tableId] = this.tableParameters[tableId];
      });
    }
  }
};
export default TableColMixin;
</script>